module.exports = __webpack_public_path__ + "static/media/autoCADAddons6.f40f56d7.png";